<template>
    <div class="modal fade text-left mx-auto" :id="element_id" tabindex="-1" role="dialog"
    aria-labelledby="myModalLabel334" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-primary" id="myModalLabel334">
                        {{ title }}
                    </h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-sm-5 mx-50 pb-4 mx-auto" style="width: 100%; height: 100%; position: relative;">
                    <video class="videos" playsinline controls data-plyr-config='{ "title": "Creditfixrr Business Company Settings Tutorial" }'>
                        <source :src="source" type="video/mp4" />
                    </video>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, reactive } from 'vue'

export default{
    name:"CfBizSettingsModalVideo",
    components:{
    },
    props:{
        element_id:{
            type: String
        },
        title: {
            type: String
        },
        source: {
            type: String
        },

    },
    setup() {
        return{

        }
    },
    mounted() {
        const $this = this;
        $(function() {
            $(`#${$this.element_id}`).on('hidden.bs.modal', function () {
                document.querySelector('video').pause();
            });
        });
    },
    watch: {

    },
    beforeMount(){

    },
    created(){

    },
    methods: {

    },

}
</script>
